module.exports = __webpack_public_path__ + "static/Portfolio-5f9bd246719b31fa5669fb997eb552f5.svg";